import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from './icon/icon.component';
import { ScopingIconsComponent } from './scoping-icons/scoping-icons.component';
import { IconAirbnbComponent } from './icon-airbnb/icon-airbnb.component';
import { IconAgodaComponent } from './icon-agoda/icon-agoda.component';
import { IconBookingComponent } from './icon-booking/icon-booking.component';
import { IconHomeawayComponent } from './icon-homeaway/icon-homeaway.component';
import { IconSmartbnbComponent } from './icon-smartbnb/icon-smartbnb.component';
import { IconPlatformComponent } from './icon-platform/icon-platform.component';
import { IconIcalPlatformComponent } from './icon-ical-platform/icon-ical-platform.component';
import { MaterialModule } from '@app/ui/material.module';
import { IconDynamicPricingComponent } from './icon-dynamic-pricing/icon-dynamic-pricing.component';

@NgModule({
  declarations: [
    IconComponent,
    ScopingIconsComponent,
    IconAgodaComponent,
    IconAirbnbComponent,
    IconBookingComponent,
    IconHomeawayComponent,
    IconSmartbnbComponent,
    IconPlatformComponent,
    IconIcalPlatformComponent,
    IconDynamicPricingComponent,
  ],
  imports: [CommonModule, MaterialModule],
  exports: [
    IconComponent,
    ScopingIconsComponent,
    IconAgodaComponent,
    IconAirbnbComponent,
    IconBookingComponent,
    IconHomeawayComponent,
    IconSmartbnbComponent,
    IconPlatformComponent,
    IconIcalPlatformComponent,
    IconDynamicPricingComponent,
  ],
})
export class IconsModule {}
